import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectTheme, setTheme } from '../slices/preferencesSlice';

export default function useTheme() {
  const dispatch = useDispatch();
  const theme = useSelector(selectTheme);
  const [effectiveDark, setEffectiveDark] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const mq = window.matchMedia('(prefers-color-scheme: dark)');

    const apply = (isDark) => {
      setEffectiveDark(isDark);
      if (isDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    };

    if (theme === 'system') {
      apply(mq.matches);
      const listener = (e) => apply(e.matches);
      mq.addEventListener ? mq.addEventListener('change', listener) : mq.addListener(listener);
      return () => {
        mq.removeEventListener ? mq.removeEventListener('change', listener) : mq.removeListener(listener);
      };
    }

    apply(theme === 'dark');
  }, [theme]);

  const set = (t) => dispatch(setTheme(t));
  const toggle = () => dispatch(setTheme(theme === 'dark' ? 'light' : 'dark'));

  return { theme, effectiveDark, setTheme: set, toggle };
}
